/**
 * O CARIMBO DO CÓDIGO QUE ESTÁ RODANDO.
 *
 * Em 23/10/2026 gastamos horas sem saber distinguir duas coisas que, na tela
 * de quem relata, são idênticas: "a correção não funcionou" e "a correção
 * ainda não chegou ao aparelho". O app instalado carrega o sistema pela
 * rede, e entre o merge e o aparelho há deploy, cache do WebView e service
 * worker — qualquer um deles pode estar um passo atrás.
 *
 * Então a tela passa a dizer de qual commit ela é. O valor é embutido no
 * pacote pelo `next.config.ts` a partir do `VERCEL_GIT_COMMIT_SHA`; fora da
 * Vercel fica "local", e aí não se mostra nada (no computador de quem
 * desenvolve o carimbo não informa nada).
 */
const bruto = process.env.NEXT_PUBLIC_BUILD_SHA ?? "";

export const BUILD_SHA = bruto && bruto !== "local" ? bruto : "";
